import styled from 'styled-components';

export const RouteInfoContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px ${({ theme }) => theme.colors.gray_300};
  z-index: 1000;

  .icon-text {
    color: ${({ theme }) => theme.colors.primary};
    margin: 0;
  }
`;

export const CorrespondentCardInfo = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 8px;

  .correspondentName {
    font-weight: bold;
    margin-bottom: 5px;
  }

  div {
    margin: 5px 0;
  }
`;
